import { queryOptions } from '@tanstack/react-query';
import {
  listTemplates,
  getTemplate,
  createTemplate,
  updateTemplate,
  deleteTemplate,
} from '@/api/generated/sdk.gen';
import type {
  TemplateSummary,
  TemplateResponse,
  CreateTemplateRequest,
  UpdateTemplateRequest,
} from '@/api/generated/types.gen';

export type {
  TemplateSummary,
  TemplateResponse,
  CreateTemplateRequest,
  UpdateTemplateRequest,
};

export interface TemplatesFilter {
  category?: 'transactional' | 'operational' | 'marketing';
  onlyActive?: boolean;
  limit?: number;
  offset?: number;
}

export function templatesQuery(filter: TemplatesFilter = {}) {
  return queryOptions({
    queryKey: ['templates', filter] as const,
    queryFn: async ({ signal }) => {
      const res = await listTemplates({
        throwOnError: true,
        signal,
        query: {
          category: filter.category,
          only_active: filter.onlyActive,
          limit: filter.limit ?? 200,
          offset: filter.offset ?? 0,
        },
      });
      return res.data;
    },
    retry: (count, err) => {
      const status = (err as { status?: number })?.status;
      return status !== 401 && status !== 404 && count < 1;
    },
    staleTime: 60_000,
  });
}

export function templateQuery(id: string) {
  return queryOptions({
    queryKey: ['template', id] as const,
    queryFn: async ({ signal }) => {
      const res = await getTemplate({
        throwOnError: true,
        signal,
        path: { id },
      });
      return res.data;
    },
    retry: (count, err) => {
      const status = (err as { status?: number })?.status;
      return status !== 401 && status !== 404 && count < 1;
    },
    staleTime: 60_000,
  });
}

export { createTemplate, updateTemplate, deleteTemplate };
